import { ContactForLinks, type GetContactProfileOutput } from '@/entities/client';
import { ReachContactValue } from '@/features/client/reach-contact';
import { SheetHeader, SheetTitle } from '@/shared/ui/panels/sheet-panel';
import { DotSeparatedText } from '@/shared/ui/text/dot-separated-text';

type Props = {
    name: string;
    profile: GetContactProfileOutput;
};

export function ContactDetailsSheetHeading({ name, profile }: Props) {
    const email = profile.emailPrimary?.trim();
    const phone = profile.phonePrimary?.trim();

    return (
        <SheetHeader variant="chart" className="pb-4">
            <div className="flex flex-col">
                <SheetTitle className="break-words">{name}</SheetTitle>
                <DotSeparatedText
                    orientation="responsive"
                    items={[
                        email && <ReachContactValue key="email" kind="email" value={email} />,
                        phone && <ReachContactValue key="phone" kind="phone" value={phone} />,
                    ]}
                />
                <ContactForLinks links={profile.clients} />
            </div>
        </SheetHeader>
    );
}
